import type { IconNode } from '../types';

/**
 * @name fan-handheld
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA0YzAtLjYuNC0xIDEtMWExNy44IDE3LjggMCAwIDEgMTYuOSAxNi45YzAgLjYtLjQgMS0xIDEuMUg1Yy0xLjEuMS0yLS44LTItMS45WiIgLz4KICA8cGF0aCBkPSJNOS45IDQuNCAzIDE5IiAvPgogIDxwYXRoIGQ9Ik0xNS43IDguMyAzLjYgMjAuNCIgLz4KICA8cGF0aCBkPSJNMTkuNiAxNC4xIDUgMjEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/fan-handheld
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const fanHandheld: IconNode = [
  [
    'path',
    {
      d: 'M3 4c0-.6.4-1 1-1a17.8 17.8 0 0 1 16.9 16.9c0 .6-.4 1-1 1.1H5c-1.1.1-2-.8-2-1.9Z',
      key: '1ta4q7',
    },
  ],
  ['path', { d: 'M9.9 4.4 3 19', key: '1v076i' }],
  ['path', { d: 'M15.7 8.3 3.6 20.4', key: '1wpozk' }],
  ['path', { d: 'M19.6 14.1 5 21', key: '120ed5' }],
];

export default fanHandheld;
